import { HttpContextToken } from '@angular/common/http';
import { defer, Observable, retry, take, throwError, timeout, timer } from 'rxjs';

// The caller owns recovery for this request. Session-expiry handling still applies.
export const QUIET_HTTP_ERRORS = new HttpContextToken<boolean>(() => false);

export function isTemporaryRequestFailure(error: { name?: string; status?: number }): boolean {
  return error?.name === 'TimeoutError' || error?.status === 0 ||
    error?.status === 408 || error?.status === 429 || (error?.status >= 500 && error?.status <= 599);
}

export function backgroundRetryDelay(error: any, retryNumber: number): number {
  const backoff = retryNumber === 1 ? 1000 : 3000;
  const retryAfter = error?.headers?.get?.('Retry-After');
  if (!retryAfter) return backoff;
  const seconds = Number(retryAfter);
  const serverDelay = Number.isFinite(seconds) ? seconds * 1000 : Date.parse(retryAfter) - Date.now();
  return Number.isFinite(serverDelay) ? Math.max(backoff, serverDelay) : backoff;
}

export function quietRead<T>(request: () => Observable<T>, timeoutMs = 15000): Observable<T> {
  return defer(request).pipe(take(1), timeout(timeoutMs), retry({
    count: 2,
    delay: (error, attempt) => isTemporaryRequestFailure(error)
      ? timer(backgroundRetryDelay(error, attempt)) : throwError(() => error),
  }));
}
